import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, RouterModule, withComponentInputBinding } from "@angular/router";
import { routes } from "./app.routes";
import { BrowserModule } from "@angular/platform-browser";
import { CalAngularModule } from "@cvx/cal-angular";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { tokenInterceptor } from "./core/interceptors/token-interceptor";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import type { Config as CalConfig } from '@cvx/cal-angular';
import config from 'src/assets/config.json';
import { environment } from 'src/environments/environment';
import { ErrorService } from "./share/services/error.service";
import { provideCharts, withDefaultRegisterables } from "ng2-charts";
import esriConfig from "@arcgis/core/config";

esriConfig.assetsPath = "/assets/arcgis";

export const applicationConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(
      BrowserModule,
      RouterModule,
      // Loads CAL configuration and provides CAL services (ConfigService, CalAngularService, RoleGuardService, CalGuardService, etc.)
      // Fix for CAL not configured properly in the azure environment
      CalAngularModule.forRoot(getCalConfigForEnvironment())

      // Starting with CAL 20, nested config is now supported.
      // The second parameter is the name of the config section.
      // CalAngularModule.forRoot('assets/config.json', 'AzureAD');
    ),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: ErrorHandler, useClass: ErrorService },
    provideCharts(withDefaultRegisterables())
  ],
};

function getCalConfigForEnvironment(): CalConfig {
  return {
    ...config,
    clientId: environment.appId,
    redirectUri: environment.appUrl
  };
}
